export default __webpack_public_path__ + "static/media/poster.522c4017.jpg";